import { t } from '~/components/I18n';
import yellowBell from '~/components/Icon/bell.png';
import { useUnreadNewCategoryNotices } from '~/components/Quick/Menu/QuickMenu.hooks';
import { QuickMenuItem } from '~/components/Quick/Menu/QuickMenuItem';
export const NoticeQuickMenuItem = () => {
  const newCommonNotices = useUnreadNewCategoryNotices('notice');

  return (
    <QuickMenuItem
      active={newCommonNotices.length > 0}
      image={yellowBell}
      label={t('citizen_quick_notice')}
    />
  );
};
